import { AssetsTranslations, TranslationsMap } from "../CountryPage";

import firstSectionMobile from "../../../assets/images/ENG/first-section-mobile_ENG.png";
import firstSectionDesktop from "../../../assets/images/ENG/first-section-desktop_ENG.jpg";
import secondSectionMobile from "../../../assets/images/ENG/second-section-mobile_ENG.png";
import secondSectionDesktop from "../../../assets/images/ENG/second-section-desktop_ENG.jpg";
import thirdSectionMobile from "../../../assets/images/ENG/third-section-mobile_ENG.png";
import thirdSectionDesktop from "../../../assets/images/ENG/third-section-desktop_ENG.jpg";
import fourthSectionMobile from "../../../assets/images/ENG/fourth-section-mobile_ENG.jpg";
import fourthSectionDesktop from "../../../assets/images/ENG/fourth-section-desktop_ENG.jpg";

export const englishTranslatedAssets: AssetsTranslations = {
  firstSectionMobile,
  firstSectionDesktop,
  secondSectionMobile,
  secondSectionDesktop,
  thirdSectionMobile,
  thirdSectionDesktop,
  fourthSectionMobile,
  fourthSectionDesktop,
};

export const englishTranslations: TranslationsMap = {
  "landingPage.selection.title": "Welcome to Nelia",
  "landingPage.hero.title": "Your support for rare kidney disease",
  "landingPage.hero.body":
    "Empowering you to make informed decision about your health",
  "landingPage.usp.ho.label": "Health overview",
  "landingPage.usp.ho.title": "Manage your health changes",
  "landingPage.usp.ho.body":
    "Log your experiences on a regular basis to observe any changes in your health. Feel more in control and informed about your kidney disease through insightful graphs.",
  "landingPage.usp.ia.label": "Stay informed",
  "landingPage.usp.ia.title": "Get content, just for you",
  "landingPage.usp.ia.body":
    "Receive recommended articles that may help you with your personal experience, and access them anytime and anywhere. Learn at your own pace and spend extra time on the topics you find most important to better understand.",
  "landingPage.usp.si.label": "Advocate for yourself",
  "landingPage.usp.si.title": "Feel empowered through preparation",
  "landingPage.usp.si.body":
    "Register and prepare for all of your upcoming appointments. Actively take part in conversations with your doctor by writing notes using our topic prompts.",
  "landingPage.usp.cs.label": "Document with ease",
  "landingPage.usp.cs.title": "Keep all your results in one place",
  "landingPage.usp.cs.body":
    "Receive recommended articles that may help you with your personal experience, and access them anytime, anywhere. Learn at your own pace and spend extra time on the topics you find most important to better understand.",
  "landingPage.moreFeatures.title": "...more features and benefits of Nelia",
  "landingPage.moreFeatures.feel.title": "Stay on track with your treatment",
  "landingPage.moreFeatures.feel.body":
    "Get support with your medication schedules and receive reminders exactly when you need them. This feature is coming soon.",
  "landingPage.moreFeatures.discover.title":
    "Tools to help you feel more organized in everyday life",
  "landingPage.moreFeatures.discover.body":
    "Customize your notifications to a schedule that suits you best.​",
  "landingPage.moreFeatures.tools.title":
    "Discover an intuitive and easy-to-use design",
  "landingPage.moreFeatures.tools.body":
    "Experience an intuitive and user-friendly interface that’s easy to navigate.​",
  "landingPage.footer.privacyPolicy": "Privacy policy",
  "landingPage.footer.licenses": "Licenses",
  "landingPage.download.title": "Download Nelia now",
  "landingPage.companionApp": "Companion app",
  "landingPage.mobile.countrySelection.australia":
    "Australia (Not in scope for now)",
  "landingPage.mobile.preLaunch.productInformation.signUp":
    "Sign up for release",
  "mobile.preLaunch.productInformation.upcomingRelease": "Upcoming release",
  "landingPage.mobile.preLaunch.productInformation.sponsor":
    "Cora BC (UK) has been sponsored by \nNovartis Pharmaceuticals UK Ltd.",
  "landingPage.PrivacyPolicy": "Privacy Policy",
};
